(function () {
	'use strict';

	angular.module('changdobels').config(httpInterceptor);

	httpInterceptor.$inject = [
		'$httpProvider',
		'HTTP_TIMEOUT'
	];

	function httpInterceptor($httpProvider, HTTP_TIMEOUT) {
		interceptor.$inject = [
			'$q',
			'$timeout'
		];

		$httpProvider.interceptors.push(interceptor);

		function interceptor( $q, $timeout ) {
			return {
				request: function ( config ) {
					config._slowAjaxPromise = $timeout(
						_reportSlowAjax.bind( null, config ),
						HTTP_TIMEOUT,
						false );

					return config;
				},
				response: function ( response ) {
					$timeout.cancel( response.config._slowAjaxPromise );

					return response;
				},
				requestError: function ( rejection ) {
					$timeout.cancel( rejection.config._slowAjaxPromise );

					_reportError( rejection );
					return $q.reject( rejection );
				},
				responseError: function ( rejection ) {
					$timeout.cancel( rejection.config._slowAjaxPromise );

					_reportError( rejection );
					return $q.reject( rejection );
				},
			};
		}

		function _reportError(rejection) {
			Raven.captureMessage('HTTP Error ' +
					rejection.status +
					( rejection.statusText ? ' ' + rejection.statusText : '' ), {
				extra: {
					action: angular.isObject( rejection.config.params ) ?
						rejection.config.params.action : undefined,
					config: angular.toJson(rejection.config),
					status: rejection.status,
					statusText: rejection.statusText,
					rejection: angular.toJson(rejection)
				}
			});
		}

		function _reportSlowAjax( config ) {
			Raven.captureMessage( "Slow AJAX", {
				extra: {
					action: angular.isObject( config.params ) ?
						config.params.action : undefined,
					config: config
				}
			} );
		}
	}
})();